<template>
   <div id="arcopay-container">
    <iframe
      :src="iframeSrc"
      frameborder="no"
      framespacing="0"
      border="0"
      width="100%"
      height="100%"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'AfterbanksWidget',
  props: {
    company_id: {
      type: [String, Number],
      required: true
    },
    bank_account_id: {
      type: String,
      required: true
    },
    service_id: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      parameters: {
        // ID de cliente
        "id": this.bank_account_id,
        // Acción del widget
        "action": "read",
        // Configuración del widget
        "countryCode": "ES",               
        "banksShownPSD2": "sandbox",
        "banksShownV3": "ALL",
        "defaultBank": this.service_id,
        "autoStart": 0,
        "defaultLanguage": "ES",
        "showSandbox": 0,
        "showSplashScreen": 0,
        "showCheckTerms": 1,
        "URLredirectAfterOK": `https://app.inmatic.ai/${this.company_id}/bank-accounts`,
        "URLredirectAfterKO": "",
        // Parámetros READ PSD2
        "dailyFrequency": 4,
        "validUntil": ""
      },
      responseMessage: '',
      iframeSrc: '',
    };
  },
  mounted() {
    const date = new Date();
    date.setDate(date.getDate() + 90);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    this.parameters.validUntil = `${dd}-${mm}-${yyyy}`

    const afterbanksIframeContainer = document.getElementById('arcopay-container');
    const afterbanksIframe = afterbanksIframeContainer.querySelector('iframe');

    this.iframeSrc = "https://www.afterbanks.com/appmain/PSD2ExternalForm/?action="+this.parameters.action+"&showSplashScreen="+this.parameters.showSplashScreen+"&showCheckTerms="+this.parameters.showCheckTerms+"&showSandbox="+this.parameters.showSandbox;

    window.addEventListener('message', this.receiveFromFrame, false);

    afterbanksIframe.addEventListener('load', () => {
      if (afterbanksIframe.contentWindow) {
        afterbanksIframe.contentWindow.postMessage(this.parameters, 'https://www.afterbanks.com/');
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receiveFromFrame);
  },
  methods: {
    receiveFromFrame(ev) {
      if (ev.data !== '' && ev.data.code !== undefined && ev.data.message !== undefined) {
        const codigo = ev.data.code;
        const mensaje = ev.data.message;

        switch (codigo) {
          case 200:
            if (this.parameters.action == 'read') {
              this.responseMessage = 'Lectura finalizada correctamente.';
            }
            break;
          case 9999:
            document.getElementById('arcopay-container').style.height = mensaje + 'px';
            window.scrollTo(0, 0);
            document.getElementById('arcopay-container').querySelector('iframe').contentWindow.postMessage({"action": "changeIframeHeight"}, 'https://www.afterbanks.com/');
            break;
          case 99999999:
            break;
          default:
            this.responseMessage = `Evento recibido: ${codigo} - ${mensaje}`;
        }
        console.log(this.responseMessage)
      }
    },
  },
  computed: {
    extraClient() {
      return this.parameters.hasOwnProperty('client') && this.parameters.client !== ''
        ? '&client=' + this.parameters.client
        : '';
    },
  },
};
</script>